import { colord } from 'colord'
import styled, { css } from 'styled-components'

import { media } from '@/common/utils/viewport'

interface ExpanderProps {
  $expanded: boolean
}

interface ExpandedProps {
  $expanded: boolean
  $maxHeight: number
}

interface RowProps {
  $selected?: boolean
  $hoverable?: boolean
}

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`

export const StyledRow = styled.tr<RowProps>`
  border-top: 1px solid #f2f2f2;

  ${({ $selected }) =>
    $selected &&
    css`
      background: ${({ theme }) =>
        colord(theme.colors.primary).alpha(0.05).toHex()};
    `}

  ${({ $hoverable }) =>
    $hoverable &&
    css`
      &:hover {
        background: ${({ theme }) =>
          colord(theme.colors.primary).alpha(0.05).toHex()};
      }
    `}
`

export const StyledHeaderCell = styled.th`
  font-size: 14px;
  font-weight: 600;
  padding: 0 6px 16px;
  vertical-align: top;

  &:first-child {
    padding-left: 12px;
  }

  &:last-child {
    padding-right: 12px;
  }

  ${media.down('sm')`
    &:first-child {
      padding-left: 2px;
    }

    &:last-child {
      padding-right: 2px;
    }
  `}
`

export const StyledCell = styled.td`
  font-size: 14px;
  font-weight: 500;
  padding: 12px 6px;

  &:first-child {
    padding-left: 12px;
  }

  &:last-child {
    padding-right: 12px;
  }

  ${media.down('sm')`
    &:first-child {
      padding-left: 2px;
    }

    &:last-child {
      padding-right: 2px;
    }
  `}
`

export const Expander = styled.span<ExpanderProps>`
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${({ $expanded }) => ($expanded ? '-180deg' : '-90deg')});
  transition: all 0.2s ease-in-out;
  cursor: pointer;
`

export const ExpendedContent = styled.div<ExpandedProps>`
  max-height: ${({ $expanded, $maxHeight }) => ($expanded ? $maxHeight : 0)}px;
  transition: all
    ${({ $expanded, $maxHeight }) =>
      Math.min($maxHeight / 600 - ($expanded ? 0 : 0.1), 0.5)}s
    ${({ $expanded }) => ($expanded ? 'ease-in-out' : 'ease-out')};
  overflow: hidden;

  & > div > * {
    background-color: #fcfcfc;
  }
`
